import { authenticatedApiFetch } from '../utils/utils'

export const allLessonsForClassService = async (classId) => {
    if (!classId) {
        return []
    }
    const res = await authenticatedApiFetch(`/imported-lessons/?class_id=${classId}`)
        .then(response => response.json())
        .catch(error => {
            console.error(error)
            return []
        })
    return Array.isArray(res) ? res : (res?.results ?? [])
}
